import React from 'react'

import { LntButton, LntTextArea } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { EditCommentProps } from './types'

export const EditComment: React.FC<EditCommentProps> = props => {
  const { message, onPatchComment, onChangeMessage, onCancel } = props

  const handleChangeMessage = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const { value } = event.target

    onChangeMessage(value)
  }

  return (
    <div className={ styles.editComment }>
      <LntTextArea
        showCount
        maxLength={ 250 }
        size={ SIZE.large }
        placeholder={ FILTERS_PLACEHOLDERS.comment }
        onChange={ handleChangeMessage }
        defaultValue={ message ?? '' }
      />
      <div className={ styles.editComment__buttons }>
        <LntButton
          type={ BUTTON_TYPE.secondary }
          size={ SIZE.small }
          onClick={ onCancel }
        >
          Отмена
        </LntButton>
        <LntButton
          type={ BUTTON_TYPE.primary }
          size={ SIZE.small }
          onClick={ onPatchComment }
        >
          Сохранить
        </LntButton>
      </div>
    </div>
  )
}
